/*
 *
 * Form
 *
 */

import React from 'react';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import { connect } from 'react-redux';
import {
  StyledForm,
  ButtonGroup
} from './styledComponents';
import validate from './validate';

import Button from 'components/Button';
import InputField from 'components/InputField';
import Loader from 'components/Loader';

const Form = ({
  handleSubmit,
  pristine,
  submitting,
  syncErrors,
  openInvalidEmailModal,
  openInvalidPasswordModal,
  openPasswordRequirementsModal
}) => {
  const isError = syncErrors && (syncErrors.email || syncErrors.password);
  return(
  <StyledForm onSubmit={handleSubmit}>
    <Field
      name='email'
      type='text'
      component={InputField}
      label='Email Address'
      placeholder='enter your email'
      validateIcon={syncErrors && !syncErrors.email}
    />
    <Field
      name='password'
      type='password'
      component={InputField}
      label='Password'
      placeholder='enter your password'
      showPasswordButton={false}
      helpIcon={true}
      helpEvent={openPasswordRequirementsModal}
    />
    <ButtonGroup>
      <Button 
        type={isError ? 'button' : 'submit'}
        disabled={submitting}
        onClick={isError ? () => syncErrors.email ? openInvalidEmailModal() : openInvalidPasswordModal() : null}>
          {submitting ? <Loader/> : 'Sign In' }
      </Button>
    </ButtonGroup>
  </StyledForm>
);}

export default reduxForm({ form: 'signIn', validate })(connect(
  state => ({
    syncErrors: getFormSyncErrors('signIn')(state),
  })
)(Form));



// WEBPACK FOOTER //
// ./src/containers/SignInPage/Form.js